import { render, staticRenderFns } from "./WorkshopList.vue?vue&type=template&id=2795770a&scoped=true&"
import script from "./WorkshopList.vue?vue&type=script&lang=js&"
export * from "./WorkshopList.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopList.vue?vue&type=style&index=0&id=2795770a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2795770a",
  null
  
)

export default component.exports